var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"window window--opened"},[_c('div',{staticClass:"window__main"},[_c('div',{staticClass:"window__content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }